var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMode = function SvgMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 5h4M5 3v4M6 17v3M7.5 18.5h-3M21 12l-3.79-1.524a3 3 0 0 1-1.664-1.663L14.011 5l-1.535 3.813a2.997 2.997 0 0 1-1.664 1.663L7.022 12H7l3.79 1.524a3 3 0 0 1 1.664 1.663L13.989 19l1.535-3.813a2.997 2.997 0 0 1 1.664-1.663L20.978 12"
  })));
};
export { SvgMode as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZjVmYWYzMTE1Yzk1YjcwZTA4Mjg2OGE3ZDBiZTdjMjUuc3ZnIjs=";